import { pickBy } from "lodash";
import mixpanel from "mixpanel-browser";
let openTime: Date;
let userId: string | undefined = "";
let globalTabName: string | undefined = "";
let globalQuestion: string | undefined = "";
let globalPollListType: Array<string> | undefined;
let mixPanelInit = false;
let globalWebName: string | undefined = "";
export const setOpenDate = () => {
    openTime = new Date();
};
export const getOpenDate = () => {
    return openTime;
};

export const getPollListType = () => {
    return globalPollListType;
};

export type Event = {
    event: string;
    previousTab?: string;
    swipeType?: string;
    eventValue?: string | number | undefined;
    question?: string | number | undefined;
    pollType?: string | undefined;
    optionIndex?: string | number | undefined;
    defaultGTMConfig: "true" | "false"; // Setting this will allow to pass event to GA using generic GTM config
};
export class Analytic {
    static setUserId = (userId?: string) => {
        window.dataLayer?.push({ userId });
        if (!!mixPanelInit) {
            mixpanel.identify(userId);
            mixpanel.people.set({ $name: userId });
            mixpanel.people.increment("page_views", 1);
        }
    };
    static setPollQuestion = (question: string, pollType: string) => {
        window.dataLayer?.push({ question });
        window.dataLayer?.push({ pollType });
        globalQuestion = question;
    };
    static setTabIndex = async (tabName: string) => {
        window.dataLayer?.push({ tabName: tabName });
        globalTabName = tabName;
    };

    static setPollRequestType = async (pollListType: Array<string>) => {
        window.dataLayer?.push({ request_poll_list: JSON.stringify(pollListType) });
        globalPollListType = pollListType;
    };

    static setAppName = async (webName: string) => {
        window.dataLayer?.push({ webName: webName });
        globalWebName = webName;
    };

    static addEvent = async (event: Event) => {
        window.dataLayer?.push(event);
        const date = new Date();
        const timestamp = date.getTime();
        const eventData = pickBy({
            ...event,
            poll: event.question || globalQuestion,
            userId,
            tabName: globalTabName,
            time: timestamp,
            webName: globalWebName,
        });
        if (!!mixPanelInit) mixpanel.track(event.event, eventData);
    };

    static initMixpanel = (token: string) => {
        mixpanel.init(token);
        mixPanelInit = true;
    };
}
